/* src/app/content/global-search-replace/global-search-replace.component.scss */
.gsr-container {
  padding: 80px 20px 20px 20px;
  background-color: white;
  color: black;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  z-index: 1000;
  box-sizing: border-box;
}
.gsr-container .mat-column-select {
  flex: 0 0 55px;
  max-width: 55px;
}
.gsr-container .mat-column-name {
  flex: 1 1 200px;
}
.gsr-container .mat-column-section {
  flex: 0 0 120px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gsr-container .mat-column-type {
  flex: 0 0 75px;
  max-width: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gsr-container .mat-column-value {
  flex: 2 1 300px;
  text-align: left;
  justify-content: flex-start;
}
.gsr-container .header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.gsr-container .header h2 {
  margin-left: 20px;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: normal;
}
.gsr-container .search-box {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 4px;
}
.gsr-container .search-box .input-group {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.gsr-container .search-box .input-group label {
  width: 100px;
  color: black;
  font-weight: bold;
}
.gsr-container .search-box .input-group input,
.gsr-container .search-box .input-group select {
  flex: 1;
  padding: 8px;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.gsr-container .search-box .input-group button {
  padding: 8px 15px;
  cursor: pointer;
}
.gsr-container .search-box .options-row {
  display: flex;
  align-items: center;
  padding-left: 80px;
}
.gsr-container .search-box .options-row mat-checkbox {
  margin-left: 20px;
}
.gsr-container .search-box .options-row .section-filter {
  margin-left: 20px;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}
.gsr-container .table-container {
  position: relative;
  min-height: 200px;
}
.gsr-container .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  font-size: 1.2em;
}
.gsr-container .no-results {
  padding: 20px;
  text-align: center;
  font-style: italic;
  color: #666;
}
.gsr-container mat-table {
  width: 100%;
  background-color: white;
  color: black;
}
.gsr-container mat-paginator {
  display: flex;
  justify-content: center;
}
.gsr-container mat-paginator ::ng-deep .mat-mdc-paginator-container {
  justify-content: center;
}
.gsr-container mat-paginator ::ng-deep .mat-mdc-paginator-range-label {
  display: none !important;
}
.gsr-container mat-row {
  cursor: default;
}
.gsr-container mat-row:hover {
  background-color: white;
}
.gsr-container mat-header-cell,
.gsr-container mat-cell {
  justify-content: flex-start;
  text-align: left;
  color: black;
}
.gsr-container .mat-checkbox-frame {
  border-color: black !important;
}
.gsr-container .mat-checkbox-checked .mat-checkbox-background,
.gsr-container .mat-checkbox-indeterminate .mat-checkbox-background {
  background-color: black !important;
}
.gsr-container .mat-checkbox-checkmark-path {
  stroke: white !important;
}
.gsr-container .highlight {
  background-color: yellow;
  font-weight: bold;
}
.gsr-container .highlight.strikethrough {
  text-decoration: line-through;
  opacity: 0.7;
}
.gsr-container .replacement {
  font-weight: bold;
  background-color: #d1ffbd;
}
/*# sourceMappingURL=global-search-replace.component.css.map */
